import faker from 'faker';

import { IAddress, IAddressData } from '../address.types';
import { createRange } from '@/utils/helpers';
import { Address } from '../address';

export function createRandomAddress(): IAddressData {
  return {
    id: faker.datatype.number(),
    address1: faker.address.streetAddress(),
    address2: faker.address.secondaryAddress(),
    address3: faker.address.streetName(),
    address4: faker.address.streetSuffix(),
    city: faker.address.city(),
    region: faker.address.state(),
    postal_code: faker.address.zipCode(),
    country: faker.address.country()
  };
}

export const mockAddressData: IAddressData[] = createRange(5).map(() =>
  createRandomAddress()
);

export const mockAddress = (
  data: IAddressData[] = mockAddressData
): IAddress[] => data.map(item => new Address(item));

export const mockPaginatedAddress = {
  count: mockAddressData.length,
  next: null,
  previous: null,
  results: mockAddressData
};
